import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/assets/css/tailwind.css'
import fb from '@/services/firebase.js'
import { Datetime } from 'vue-datetime'

//https://mariomka.github.io/vue-datetime/?ref=madewithvuejs.com
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)

Vue.config.productionTip = false

let app

fb.auth.onAuthStateChanged(user => {
  if (!app) {
    if (user) {
      store.dispatch('setUser', user)
    }
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
